import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { injectIntl } from 'react-intl'

import { connect } from 'react-redux'
import { Modal } from 'containers/misc'
import { Title, Section } from 'components/layout'
import { Button } from 'components/misc'
import { modal } from 'redux/modules/app'
import { apiReports } from 'helpers/decorators/api'

const enhance = compose(apiReports(), connect(null, { modal }), injectIntl)

class Export extends Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    reports: PropTypes.object.isRequired,
    exportName: PropTypes.string.isRequired,
    exportSchemeValue: PropTypes.string.isRequired,
    additionalParams: PropTypes.object,
    toExport: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    isReportPreloading: PropTypes.bool,
    onGenerateExport: PropTypes.func.isRequired,
    count: PropTypes.number,
    exportLimit: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool
    ])
  }

  static defaultProps = {
    exportLimit: 1000
  };

  render() {
    const {
      reports,
      toExport,
      exportName,
      isReportPreloading,
      exportSchemeValue,
      additionalParams,
      intl,
      count,
      exportLimit
    } = this.props

    // If exportLimit is false then the export is unrestricted
    if (exportLimit !== false && count && count > exportLimit) {
      return <div />
    }

    return (
      <div>
        <Button
          secondary
          small
          intlKey="button.export_table"
          onClick={() => this.props.modal('modal-export-participants')}
        >
          Export table
        </Button>
        <Modal id="modal-export-participants" compact>
          <Section
            loading={reports.loading || isReportPreloading}
            inModal
            loadingDescription={intl.formatMessage({
              id: 'label.generating',
              defaultMessage: 'Generating...'
            })}
            loadingNote={intl.formatMessage({
              id: 'label.if_download_doesnt',
              defaultMessage: "If download doesn't start automatically, please check popup settings in your browser"
            })}
          >

            <Title intlKey="moduleTitle.export" h2>
              Export
            </Title>
            <Button
              link
              onClick={() =>
                this.props.onGenerateExport({
                  toExport,
                  exportName,
                  exportSchemeValue,
                  additionalParams
                })}
            >
              Generate XLS
            </Button>
          </Section>
        </Modal>
      </div>
    )
  }
}

export default enhance(Export)
